export default __webpack_public_path__ + "static/thewomansavingpalestinianfood-a42b94ec77b80f35f9c98e08416cb426.jpg";